import React from 'react'
import Component from './component'

export {
  Component
}
export default React.memo(Component)
